// src/router/index.js
import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from "@/stores/authStore";

// Private
import Home from "@/views/home/index";
import Explore from "@/views/explore/index";
import Match from "@/views/match/index";
import Call from "@/views/call/index";
import Chat from "@/views/chat/index";

// Public
import NotFound from "@/views/notFound";
import NotAuthorized from "@/views/notAuthorized";

// Layout
import PrivateLayout from "@/layouts/privateLayout";
import Maintenance from "@/views/maintenance.vue";

const isMaintenance = process.env.VUE_APP_MAINTENANCE_MODE === "true";

const routes = isMaintenance ? [
  {
    path: "/:catchAll(.*)",
    name: "Maintenance",
    component: Maintenance,
  },
] : [
  {
    path: "/",
    component: PrivateLayout,
    children: [
      {
        path: "/",
        name: "home",
        component: Home,
      },
      {
        path: "/explore",
        name: "explore",
        component: Explore,
      },
      {
        path: "/match",
        name: "match",
        component: Match,
      },
      {
        path: "/call",
        name: "call",
        component: Call,
      },
      {
        path: "/chat",
        name: "chat",
        component: Chat,
      },
      {
        path: "/401",
        name: "notAuthorized",
        component: NotAuthorized,
      },
      { path: "/:pathMatch(.*)*", name: "notFound", component: NotFound },
    ],
    meta: {
      requireAuth: false,
    },
  },
];

const router = createRouter({ history: createWebHistory(), routes });

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();
  const requiresAuth = to.matched.some((x) => x.meta.requireAuth);
  const roles = to.meta.roles;

  // Verificar se o usuário está autenticado
  if (requiresAuth && !authStore.isAuthenticated) {
    next({ name: "login" });
    return;
  }

  // Verificação de papel (roles)
  if (roles) {
    const userRoles = authStore.user?.roles || [];
    const authorized = roles.some((role) => userRoles.includes(role));

    if (!authorized) {
      next({ name: "notAuthorized" });
      return;
    }
  }

  // Verificar a expiração do token
  const expiresAt = localStorage.getItem("expiresAt");
  if (expiresAt && new Date().getTime() > expiresAt) {
    authStore.logout(); // Realiza o logout
    next({ name: "login" }); // Redireciona para login
    return;
  }

  next(); // Continuar a navegação
});
export default router;
